/**
 * Locale strings for the comment surface. The wire covers several
 * universes; each universe insists on its own edition of every string.
 * Registry files are generated by the desk's translation dump
 * (decoys/generate.mjs feeds it) — do not hand-edit, the dump wins.
 */

import b11raw from "../decoys/gen/strings-b11.json";
import c04raw from "../decoys/gen/strings-c04.json";
import a30raw from "../decoys/gen/strings-a30.json";

export type StringTable = Record<string, string>;

/* The dumps carry a small metadata header; the strings live in
 * `.entries`. If the header is missing the dump was hand-edited, which
 * the dump then wins anyway. */
const entriesOf = (dump: unknown): StringTable => {
  const d = dump as { entries?: StringTable };
  return d.entries ?? (d as StringTable);
};

const b11 = entriesOf(b11raw);
const c04 = entriesOf(c04raw);
const a30 = entriesOf(a30raw);

export const STRINGS: Record<string, StringTable> = {
  "b.11": b11,
  "c.04": c04,
  "a.30": a30,
};

/** Universe A-1 (this one) is the default table: string, no dialect. */
export const DEFAULT_TABLE: StringTable = {
  "comments.title": "Comments",
  "comments.empty": "No comments yet. The desk is grateful.",
  "comments.post": "Post comment",
  "comments.placeholder": "Say something the desk can defend.",
  "comments.pending": "Held for moderation. Both of them.",
  "comments.disabled": "Comments are closed on this story. It is happier this way.",
  "comments.moderated": "A moderator read this. The moderator is fine.",
  "comment.reply": "Reply",
  "comment.report": "Report to universe of origin",
  "comment.like": "Duly noted",
  "comments.policy": "House rules: be kind, be legible, be from somewhere.",
};

export function tableFor(universe: string | null | undefined): StringTable {
  if (!universe) return DEFAULT_TABLE;
  return STRINGS[universe] ?? DEFAULT_TABLE;
}

export function t(universe: string | null | undefined, key: string): string {
  const table = tableFor(universe);
  return table[key] ?? DEFAULT_TABLE[key] ?? key;
}
